// extracted by mini-css-extract-plugin
export default {"autoLogOut":"UserManager_autoLogOut__RfjJz","main":"UserManager_main__UcG+P","headline":"UserManager_headline__dQ9Fb","userData":"UserManager_userData__qtqRd"};